<div class="bmc-working-time-schema-days">
  <div class="bmc-working-time-schema-days__table">
    <p class="bmc-working-time-schema-days__description">{{"WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS_DESCRIPTION" | translate}}</p>
    <ng-container *ngIf="!(nonWorkingDays$ | async)">
      <!--
      <div *ngIf="!(nonWorkingDays$ | async).length">
        <p>{{"WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS_EMPTY" | translate}}</p>
      </div>
      -->
    </ng-container>
    <table class="bz-table bz-space--stack-m">
      <thead>
      <tr>
        <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
          <div class="bz-table__col-title" *ngIf="col.visible">
            <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let day of (nonWorkingDays$ | async)">
        <td class="bz-table__cell" *ngFor="let col of columns" [ngClass]="{'bz-color-bg--theme-100': ( selectedSchemaRange && (day.idWorkingTimeData === selectedSchemaRange?.idWorkingTimeData) )}">
          <div *ngIf="col.visible">
            <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'date' ">
              {{ day[col.key] | date:'MM/dd/yyyy'}}
            </div>
            <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'number' ">
              {{getDaysBetween(day["fromDate"], day["toDate"])}}
            </div>
            <bzg-button-icon *ngIf="col.type === 'edit' "[icon]="'icon-edit'" (click)="selectSchemaRange(day)"></bzg-button-icon>
            <bzg-button-icon *ngIf="col.type === 'delete' "[icon]="'icon-delete'" (click)="deleteWorkingTimeSchemaRange(day)"></bzg-button-icon>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <ng-form #daysForm="ngForm" class="bmc-working-time-schema-days__config">
    <div class="bz-space--stack-s">
      <label class="bz-form-label">{{'WORKING_TIME_SCHEMA.DATE_TYPE' | translate}}</label>
    </div>
    <bzg-select class="bz-space--stack-m" [placeholder]="'WORKING_TIME_SCHEMA.SELECT_DATE_TYPE' | translate" name="select" [(value)]="currentDateType">
      <bzg-option value="exact">{{'WORKING_TIME_SCHEMA.EXACT' | translate}}</bzg-option>
      <bzg-option value="range">{{'WORKING_TIME_SCHEMA.RANGE' | translate}}</bzg-option>
    </bzg-select>
    <bzg-date-picker *ngIf="currentDateType==='exact'" [(ngModel)]="onDate" name="on-date">
        {{'WORKING_TIME_SCHEMA.ON_DATE' | translate}}
        </bzg-date-picker>
      <bzg-date-picker *ngIf="currentDateType==='range'" [(ngModel)]="startDate" [maxDate]="finishDate" name="start-date">
        {{'WORKING_TIME_SCHEMA.START_DATE' | translate}}
      </bzg-date-picker>
      <bzg-date-picker *ngIf="currentDateType==='range'" [(ngModel)]="finishDate" [minDate]="startDate" name="finish-date">
        {{'WORKING_TIME_SCHEMA.FINISH_DATE' | translate}}
      </bzg-date-picker>
    <ng-container *ngIf="!selectedSchemaRange">
      <bzg-button-secondary *ngIf="currentDateType" [disabled]="isInvalid()" 
        class="bmc-working-time-schema-days__config__button bz-space--inline-s" [size]="'s'" (click)="onSetNonWorkingDate()">
        {{'WORKING_TIME_SCHEMA.SET_NEW_NON_WORKING_DAY' | translate}}
      </bzg-button-secondary>
    </ng-container>
    <div class="working-ts__modify-buttons" *ngIf="selectedSchemaRange">
      <bzg-button-primary *ngIf="currentDateType" [disabled]="isInvalid()" 
        class="bmc-working-time-schema-days__config__button bz-space--inline-s" [size]="'s'" (click)="modifySchemaRange(selectedSchemaRange)">
        {{'WORKING_TIME_SCHEMA.APPLY_CHANGES' | translate}}
      </bzg-button-primary>
      <bzg-button-secondary *ngIf="currentDateType" [disabled]="isInvalid()" 
        class="bmc-working-time-schema-days__config__button bz-space--inline-s" [size]="'s'" (click)="cancelModify()">
        {{'GLOBAL.CANCEL' | translate}}
      </bzg-button-secondary>
    </div>
  </ng-form>
</div>
